import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { combineClasses } from "../../../utilities/combineClasses.js";
import BaseTextInputAdornments_module from "./BaseTextInputAdornments.module.js";
import { BaseButton, ButtonAdornmentIcon } from "../../button/internal/BaseButton.js";
const AdornmentButton = /*#__PURE__*/ forwardRef(({ className, preventFocusOnClick = true, onMouseDown, icon, iconProps, ...props }, ref)=>/*#__PURE__*/ jsx(BaseButton, {
        variant: "ghost",
        action: "secondary",
        className: combineClasses(className, BaseTextInputAdornments_module.adornmentButton),
        onMouseDown: (event)=>{
            if (preventFocusOnClick) event.preventDefault();
            onMouseDown?.(event);
        },
        startAdornment: icon ? /*#__PURE__*/ jsx(ButtonAdornmentIcon, {
            icon: icon,
            ...iconProps
        }) : void 0,
        ...props,
        ref: ref
    }));
AdornmentButton.displayName = 'AdornmentButton';
const AdornmentButtonSeparator = /*#__PURE__*/ forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ jsx("div", {
        "aria-hidden": true,
        className: combineClasses(BaseTextInputAdornments_module.adornmentSeparator, className),
        ...props,
        ref: ref
    }));
AdornmentButtonSeparator.displayName = 'AdornmentButtonSeparator';
const AdornmentText = /*#__PURE__*/ forwardRef(({ children, className, ...props }, ref)=>/*#__PURE__*/ jsx("div", {
        ...props,
        className: combineClasses(className, BaseTextInputAdornments_module.adornmentText),
        ref: ref,
        children: children
    }));
AdornmentText.displayName = 'AdornmentText';
const AdornmentIcon = /*#__PURE__*/ forwardRef(({ icon: Icon, className, disabled, ...props }, ref)=>Icon ? /*#__PURE__*/ jsx(Icon, {
        "aria-hidden": true,
        size: "small",
        className: combineClasses(className, BaseTextInputAdornments_module.adornmentIcon, disabled && BaseTextInputAdornments_module.disabled),
        ...props,
        ref: ref
    }) : null);
AdornmentIcon.displayName = 'AdornmentIcon';
export { AdornmentButton, AdornmentButtonSeparator, AdornmentIcon, AdornmentText };
